import { useAppDispatch } from 'app/hooks';
import { useTranslation } from 'react-i18next';
import { DocumentActionComponent } from 'sanity';
import { useRevalidatePageByDomainMutation } from 'services/template-app';
import { setErrorMessage, setSuccessMessage } from 'store/toast-slice';

export const RevalidateAboutPage: DocumentActionComponent = (props) => {
    const dispatch = useAppDispatch();
    useTranslation('sanity');
    const [revalidatePageByDomain, { isSuccess: revalidateSuccess, isError: revalidateError }] =
        useRevalidatePageByDomainMutation();
    return {
        label: 'Revalidate About Page',
        disabled: props.draft !== null,
        onHandle: async () => {
            if (props.published && props.published.domainName)
                await revalidatePageByDomain({
                    domainName: props.published.domainName as string,
                    paths: ['/about', '/en/about'],
                });

            // TODO: First time revalidation happens, message is not shown
            revalidateError && dispatch(setErrorMessage({ key: 'SANITY.ABOUT_PAGE_REVALIDATION_ERROR' })); // TODO: see how to implemnt this correctly
            revalidateSuccess && dispatch(setSuccessMessage({ key: 'SANITY.ABOUT_PAGE_REVALIDATION_SUCCESS' })); // TODO: see how to implemnt this correctly
        },
    };
};
